<longmoon-star
  *ngFor="let star of starField"
  [color]="star.color"
  [period]="star.period"
  [size]="star.size"
  [xPos]="star.x"
  [yPos]="star.y"></longmoon-star>
